import PropTypes from 'prop-types';
import React, {
    createContext,
    useContext,
    useEffect,
    useState,
    useCallback
} from 'react';
import DialingCodeService from 'services/dialing-code.service';

const DialingCodesContext = createContext(null);

export const DialingCodesProvider = ({ children }) => {
    const [countries, setCountries] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchCountries = useCallback(async () => {
        if (countries.length) return;

        try {
            setLoading(true);
            const data = await DialingCodeService.getDialingCodes();
            setCountries(data || []);
        } catch (e) {
            console.error('Failed to fetch countries', e);
        } finally {
            setLoading(false);
        }
    }, [countries]);

    useEffect(() => {
        if (!countries.length) {
            fetchCountries();
        }
    }, [countries.length, fetchCountries]);

    return (
        <DialingCodesContext.Provider
            value={{
                countries,
                loading
            }}
        >
            {children}
        </DialingCodesContext.Provider>
    );
};

DialingCodesProvider.propTypes = {
    children: PropTypes.node
};

export function useDialingCodes() {
    const context = useContext(DialingCodesContext);

    if (!context) {
        throw new Error('useDialingCodes must be used within a DialingCodesProvider');
    }

    return context;
}
